import api from 'api';
import {useEffect} from 'react';
import {useQuery} from 'react-query';
import {useLocation} from 'react-router-dom';
import {ListResponse, Order} from 'types';

const fetchData = async () => {
  const {data} = await api.get<ListResponse<Order>>('/routes/deliveries/', {
    params: {
      limit: 1,
    },
  });
  return data;
};

function useController() {
  const {pathname} = useLocation();
  const {data, refetch} = useQuery(['orders_one'], fetchData);

  useEffect(() => {
    if (pathname === '/deliveries/delivery_planner') {
      refetch();
    }
  }, [pathname, refetch]);

  return {
    pathname,
    hasOrder: !!data?.results?.length,
  };
}

export default useController;
